var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.23047,
    cy: 7.5,
    r: 6.16047,
    stroke: "#FFD252",
    strokeWidth: 2.14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.23047,
    cy: 7.5,
    r: 7.03047,
    stroke: "black",
    strokeWidth: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.23428,
    cy: 7.50039,
    r: 5.74912,
    fill: "#FFF6DC",
    stroke: "black",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23047 1.55127L7.23047 2.64957",
    stroke: "black",
    strokeWidth: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4412 3.38184L10.709 4.11404",
    stroke: "black",
    strokeWidth: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0849 7.4541H12.0781",
    stroke: "black",
    strokeWidth: 0.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3943 11.6184L10.6621 10.8862",
    stroke: "black",
    strokeWidth: 0.35
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23047 13.4037V12.397",
    stroke: "black",
    strokeWidth: 0.35
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06445 11.6184L3.79665 10.8862",
    stroke: "black",
    strokeWidth: 0.35
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36914 7.40869H2.46744",
    stroke: "black",
    strokeWidth: 0.35
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11133 3.33594L3.88929 4.1139",
    stroke: "black",
    strokeWidth: 0.35
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39718 3.57792C7.32884 3.50957 7.21804 3.50957 7.14969 3.57792L6.036 4.69161C5.96766 4.75995 5.96766 4.87076 6.036 4.9391C6.10434 5.00744 6.21515 5.00744 6.28349 4.9391L7.27344 3.94915L8.26339 4.9391C8.33173 5.00744 8.44253 5.00744 8.51087 4.9391C8.57922 4.87076 8.57922 4.75995 8.51087 4.69161L7.39718 3.57792ZM7.27344 7.40842H7.09844V7.48091L7.14969 7.53216L7.27344 7.40842ZM9.28699 9.59697C9.38364 9.59697 9.46199 9.51862 9.46199 9.42197L9.46199 7.84697C9.46199 7.75032 9.38364 7.67197 9.28699 7.67197C9.19034 7.67197 9.11199 7.75032 9.11199 7.84697L9.11199 9.24697H7.71199C7.61534 9.24697 7.53699 9.32532 7.53699 9.42197C7.53699 9.51862 7.61534 9.59697 7.71199 9.59697H9.28699ZM7.09844 3.70166V7.40842H7.44844V3.70166H7.09844ZM7.14969 7.53216L9.16324 9.54571L9.41073 9.29822L7.39718 7.28468L7.14969 7.53216Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.3d97a4333c781802bc00b3ee8b5feda5.svg";
export { ForwardRef as ReactComponent };